// request-util.js
import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { aesDecrypt, aesEncrypt, objExt } from "@xmiles/holopix-helper";


const useAes = ["production", "gray"].includes(import.meta.env.VITE_ENV);

// 创建独立实例
const request = axios.create({
  baseURL: import.meta.env.VITE_SERVICE_URL,
  timeout: 60 * 10 * 1000 * 3, // 3分钟,因为模型生成接口可能会耗时3分钟
  headers: {
    "Content-Type": "application/json"
  }
});

request.interceptors.request.use(
  (config) => {
    //如果没有data包裹先包裹data
    if (!("data" in config.data)) {
      config.data = { data: config.data };
    }

    if (useAes) {
      if (config?.method?.toLowerCase() === "post") {
        const value = aesEncrypt(objExt.stringify(config.data));
        config.data = value;
      }
    } else {
      // 加密后门 添加后则不使用加密
      config.headers.xmReqRaw = 1;
      config.headers.xmRespRaw = 1;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

request.interceptors.response.use(
  async (response: AxiosResponse): Promise<AxiosResponse> => {
    if (useAes && typeof response.data === "string") {
      const result = aesDecrypt(response.data);
      response.data = objExt.parse(result, {});
    }

    if (response.data && response.data.code >= 0) {
      if (response.data.code === 0) {
        return response.data;
      }
    }

    return Promise.reject(response.data) as any;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 核心请求方法
 * @param {string} url 请求地址
 * @param {object} options 请求配置
 * @returns {Promise}
 */
const _request = async (url: string, options: AxiosRequestConfig): Promise<any> => {
  try {
    const response = await request({ url, ...options });
    return response.data;
  } catch (error) {
    // 这里可以添加错误处理逻辑
    console.error("Request Error:", error);
    throw error;
  }
};

// 常用方法快捷封装
export const _getRequest = (url: string, params: any, config = {}) => _request(url, { method: "GET", params, ...config });

export const _postRequest = (url: string, config: AxiosRequestConfig) => _request(url, { method: "POST", ...config });

// export const put = (url: string, data: any, config = {}) => _request(url, { method: "PUT", data, ...config });

// export const del = (url: string, params: any, config = {}) => _request(url, { method: "DELETE", params, ...config });

// 默认导出核心方法
export default _request;
